import { gql, useQuery } from '@apollo/client';

export const GET_LIMITED_EMPLOYEE_BY_ID = gql`
  query getPublicMemberById($memberId: ObjectId!) {
    getPublicMemberById(memberId: $memberId) {
      _id
      account {
        email
      }
      profile {
        firstName
        lastName
        gender
        birthday
        personalEmail
        nationality
        socials {
          linkedIn
        }
      }
      employeePersonalInfo {
        employeeNumber
        status
      }
      activeWorkingCondition {
        employmentType
        contracts {
          hireDate
          endDate
          contractType
        }
        occupationType
        paidVacation
        company {
          name
        }
        companyLocation {
          name
        }
        companyBusinessAddress {
          zipCode
          street
          city
          country
        }
        companyDepartment {
          name
        }
        job {
          title
        }
      }
    }
  }
`;

export const useGetLimitedEmployeeById = (employeeId: string) => {
  const { data, loading } = useQuery(GET_LIMITED_EMPLOYEE_BY_ID, {
    variables: {
      memberId: employeeId,
    },
    skip: !employeeId,
  });

  const employee = data?.getPublicMemberById || {};

  return { employee, loading };
};
